/*
 * @Author: Dom
 * @Date: 2022-05-18 14:36:09
 * @LastEditTime: 2022-07-29 16:45:39
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\locales\zh-CN.ts
 */
export default{
    'page.personal.center.account': '账号认证',
    'page.personal.center.customer': '客户信息',
    'page.personal.center.registered': '注册账户',
    'page.personal.center.notcertified': '未认证',
    'page.personal.center.certifing': '认证中',
    'page.personal.center.certified': '已认证',
    'page.personal.center.certifiedfail': '认证失败',
    'page.personal.center.authstatus': '认证状态',
    'page.personal.center.customernumber': '客户编号',
    'page.personal.center.password': '密码',
    'page.personal.center.modify': '修改',
    'page.personal.center.customertype': '客户类型',
    'page.personal.center.person': '个人',
    'page.personal.center.enterprise': '企业',
    'page.personal.center.contractstatus': '合同状态',
    'page.personal.center.notsigned': '未签署',
    'page.personal.center.signeing': '签署中',
    'page.personal.center.clicksign': '点击签署',
    'page.personal.center.signed': '已签署',
    'page.personal.center.phonebind': '绑定手机号码',
    'page.personal.center.clickbind': '绑定',
    'page.personal.center.clickchange': '修改',
    'page.personal.center.title.changepassword': '修改密码',
    'page.personal.center.title.bindphone': '绑定手机号码',
    'page.personal.center.title.changephone': '修改手机号码',
    'page.personal.center.title.modify': '修改',
}
